import React from 'react'
import ButtonComponent from '../../../../components/Buttons/ButtonComponent'
import TableEPL from '../TableEPL/TableEPL';
import { Grid, Stack } from '@mui/material';
import { showToast } from '../../../../components/ui';

const TabCostEMKL = (props) => {
  const title = 'Cost EMKL'
  const contactTypeName = 'EMKL'
  const contactTypeId = 6
  const income = false

  const handleAdd = () => {
    if (props.shipmentNo !== '') {
      props.handleAdd(title, contactTypeName, contactTypeId, income)
    }
    else {
      showToast({ type: 'error', message: 'Please Select Shipment Number First!' });
    }
  }

  const handleEdit = () => {
    if (props.selectedDetailCostEMKL.sequence === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' });
    } else {
      props.handleEdit(title, contactTypeName, contactTypeId, income)
    }
  }

  const handleConvert = () => {
    if (props.selectedDetailCostEMKL.sequence === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' });
    } else {
      props.handleConvert(title, contactTypeName, contactTypeId, income)
    }
  }

  const handleDoubleClick = () => {
    handleEdit()
  }

  const handleDelete = () => {
    if (props.selectedDetailCostEMKL.bookingDetailId === 0) {
      props.handleDelete(contactTypeId, income)
    }
    else {
      showToast({ type: 'error', message: 'Can\'t Delete This Data!' });
    }
  }

  return (
    <div className='rounded-10'>
      <TableEPL
        key={9}
        isReadOnly={props.isReadOnly}
        dataList={props.CostEMKLList}
        ignoreAccess={props.ignoreAccess}
        setDataList={props.setCostEMKLList}
        setSelectedDetail={props.setSelectedDetailCostEMKL}
        selectedDetail={props.selectedDetailCostEMKL}
        handleDoubleClick={handleDoubleClick}
        contactTypeName={contactTypeName}
        ttlUsd={props.estCostUSDEMKL}
        ttlIdr={props.estCostIDREMKL}
        totalSData={props.totalCostSEMKL}
        totalNData={props.totalCostNEMKL}
        key1={9}
        key2={9}
        type={2}
        openClose={props.openCloseCE}
        setOpenClose={props.setOpenCloseCE}
        openClose2={props.openCloseCE2}
        setOpenClose2={props.setOpenCloseCE2}
        dataDetail={props.dataDetail}
        setDataDetail={props.setDataDetail}
        countSum={props.countSum}
        countTotalData={props.countTotalData}
      />

      <Grid container item direction="row" className='mt-3'>
        <Grid item xs={10}>
          <Stack direction={'row'} spacing={'10px'}>
            {ButtonComponent.AddButton(handleAdd, '', props.isReadOnly)}
            {ButtonComponent.EditButton(handleEdit, '', props.isReadOnly)}
            {ButtonComponent.DeleteButton(handleDelete, '', props.isReadOnly)}
            {ButtonComponent.ConvertButton(handleConvert, props.isReadOnly, true)}
          </Stack>
        </Grid>

        <Grid item xs={2} className='text-end' display={'flex'} justifyContent={'flex-end'}>
          {ButtonComponent.AddButton(() => props.handleAddTrucking(title, contactTypeName, contactTypeId, income), 'Trucking', props.isReadOnly, true)}
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(TabCostEMKL)